import React from 'react';
import { createPortal } from 'react-dom';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import editorStateToRawContent from '../utilities/editorStateToRawContent';
import editorStateToHTML from '../utilities/editorStateToHTML';
import saveDraftAPI from '../../api/save-draft';
import { EVENTS } from '../../utilities/CONSTANTS';

const SECOND = 1000;

const DRAFT_SAVING_DEFAULT = 'Draft';
const DRAFT_SAVING_STATUS = 'Saving draft...';
const DRAFT_SAVED_STATUS = 'Draft saved';

const TEMPLATE_SAVING_DEFAULT = 'Template';
const TEMPLATE_SAVING_STATUS = 'Saving template...';
const TEMPLATE_SAVED_STATUS = 'Template saved';

const DRAFT_404_ERROR = 'Error: Unable to find draft';
const DRAFT_422_ERROR = 'Error: Unable to save draft';
const DRAFT_500_ERROR = 'Error: Something went wrong while saving your draft. Contact us if problem persists';
const DRAFT_GENERAL_ERROR = 'Error: Unable to save draft. Check your internet connection and back up changes locally';

const DRAFT_CLASS_STATUS_DEFAULT = '';
const DRAFT_CLASS_STATUS_ERROR = 'red';

const isTemplateDraft = () => window._tettraDraft && window._tettraDraft.is_template;

const getHTML = (editorState) => {
    if (editorState && Object.keys(editorState).length) {
        return editorStateToHTML(editorState);
    }
    return null;
};

class EditorAutosave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saveStatusText: isTemplateDraft() ? TEMPLATE_SAVING_DEFAULT : DRAFT_SAVING_DEFAULT,
            saveStatusClass: DRAFT_CLASS_STATUS_DEFAULT,
            draft: {
                owner_id: null,
                title: null,
                category_id: null,
                folder_id: null,
                raw_editor_state: null,
            },
            disabledAutoSave: null,
        };
        this.checkDraft = debounce(this.checkDraft.bind(this), SECOND, { maxWait: 5 * SECOND });
    }

    componentDidMount() {
        window.addEventListener(EVENTS.UPDATED_DRAFT_VALUES, this.checkDraft);
        window.addEventListener(EVENTS.DISABLE_AUTO_SAVE, this.disableAutoSave);
        $('#post-editor-title').on('keydown', this.checkDraft);
        $('.page-owner-submit').on('click', this.checkDraft);
    }

    componentWillUnMount = () => {
        window.removeEventListener(EVENTS.UPDATED_DRAFT_VALUES, this.checkDraft);
        window.removeEventListener(EVENTS.DISABLE_AUTO_SAVE, this.disableAutoSave);
        $('#post-editor-title').off('keydown');
        $('.page-owner-submit').off('click', this.checkDraft);
    };

    componentDidUpdate() {
        this.checkDraft();
    }

    disableAutoSave = () => {
        this.setState({ disabledAutoSave: true });
    };

    checkDraft() {
        const { draft: prevDraft, disabledAutoSave } = this.state;
        const { editorState } = this.props;
        if (disabledAutoSave) return;
        if (!window._tettraDraft) return;
        const raw_editor_state = editorState && editorStateToRawContent(editorState);
        const {
            title, owner_id, category_id, folder_id,
        } = window._tettraDraft;
        const draft = {
            title, owner_id, category_id, folder_id, raw_editor_state,
        };

        if (JSON.stringify(draft) !== JSON.stringify(prevDraft)) {
            this.saveDraft(draft);
        }
    }

    saveDraft(draft) {
        if (!window.draftId) return;
        let saveStatusText = isTemplateDraft() ? TEMPLATE_SAVING_STATUS : DRAFT_SAVING_STATUS;
        let saveStatusClass = DRAFT_CLASS_STATUS_DEFAULT;
        this.setState({ draft, saveStatusText, saveStatusClass });
        const body = getHTML(window._tettraDraft.editorState);
        saveDraftAPI(
            window.draftId,
            draft.title,
            Number.isInteger(draft.category_id) ? draft.category_id : null,
            Number.isInteger(draft.folder_id) ? draft.folder_id : null,
            draft.owner_id,
            JSON.stringify(draft.raw_editor_state),
            body,
        ).then(() => {
            saveStatusText = isTemplateDraft() ? TEMPLATE_SAVED_STATUS : DRAFT_SAVED_STATUS;
            return this.setState({ saveStatusText });
        }).catch((error) => {
            console.error(error, 'error saving draft');
            if (error.status === 404) {
                saveStatusText = DRAFT_404_ERROR;
            } else if (error.status === 422) {
                saveStatusText = `${DRAFT_422_ERROR}: ${error?.responseJSON?.message}`;
            } else if (error.status === 500) {
                saveStatusText = DRAFT_500_ERROR;
            } else {
                saveStatusText = DRAFT_GENERAL_ERROR;
            }
            saveStatusClass = DRAFT_CLASS_STATUS_ERROR;
            return this.setState({ saveStatusText, saveStatusClass });
        });
    }

    render() {
        const { saveStatusText, saveStatusClass } = this.state;

        const $saveStatus = document.getElementById('save-status');

        if (!$saveStatus) return null;

        return createPortal(<span className={saveStatusClass}>{saveStatusText}</span>, $saveStatus);
    }
}

export default EditorAutosave;
